import { createModel } from '@rematch/core';
import { IRootModel } from 'app/store';
import { ITimerState } from 'entities/Timer/Timer.models';
import { timerReducers } from 'entities/Timer/Timer.reducers';
import { timerEffects } from 'entities/Timer/Timer.effects';

export const timer = createModel<IRootModel>()({
  state: {
    data: null,
    loading: false,
    isRunning: false,
    untrackedTime: 0,
  } as ITimerState,
  reducers: timerReducers,
  effects: timerEffects,
});
